<template>
    <div class="property-value-screen">
        <header>
            <div
                class="container d-flex justify-content-between align-items-center py-4"
            >
                <div class="brand-logo" style="cursor: pointer;" @click="goToHome()">
                    <img
                        src="/images/logo_color.svg"
                        alt="Redbuyers Logo"
                        width="180"
                    />
                </div>
                <div class="text-right">
                    <h6 class="font-weight-bold">
                        <i class="fa-solid fa-location-dot mr-3"></i>{{ selectedAddress }}
                    </h6>
                </div>
            </div>
            <div class="container">
                <a href="javascript:void(0)" @click.prevent="goBack" class="btn btn-primary btn-sm d-inline-block d-md-none mt-4">
                    <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
                </a>
            </div>
        </header>
        <main class="py-4 p-lg-0">
            <div class="container">
                <div class="text-center mb-5">
                    <h1 class="mb-4">
                        Two home pricing options to choose with us.
                    </h1>
                    <h3 class="text-muted">
                        Click the option that works best for you.
                    </h3>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-4 mb-md-0">
                        <div class="card h-100">
                            <div class="card-header bg-transparent pt-4">
                                <h4
                                    class="card-title text-center text-primary font-weight-bold"
                                >
                                    CASH OFFER
                                </h4>
                                <h6 class="text-center text-primary font-weight-bold">
                                    SELL TO US
                                </h6>
                            </div>
                            <div class="card-body pb-4">
                                <ul class="offer-ul mb-5 font-weight-bold">
                                    <li>
                                        We buy your home in AS-IS condition.
                                    </li>
                                    <li>No listing & repair requires.</li>
                                    <li>
                                        Cash offer price may be lower than
                                        Back-up offer since we have extra cost
                                        of closing, re-modeling, and reselling
                                        cost.
                                    </li>
                                </ul>
                                <div class="text-center">
                                    <button class="btn btn-primary btn-sm" @click="submitForm()">
                                        GET MY OFFER
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card h-100">
                            <div class="card-header bg-transparent pt-4">
                                <h4
                                    class="card-title text-center text-primary font-weight-bold"
                                >
                                    BACK-UP OFFER
                                </h4>
                                <h6 class="text-center text-primary font-weight-bold">
                                    LIST WITH US
                                </h6>
                            </div>
                            <div class="card-body pb-4">
                                <ul class="offer-ul mb-4 font-weight-bold">
                                    <li>List the house for maximum value.</li>
                                    <li>
                                        Our back-up offer is minimum guaranteed
                                        selling price sales assurance.
                                    </li>
                                    <li>
                                        Premium realtor selling service
                                        including staging, HD photos, and best
                                        marketing.
                                    </li>
                                </ul>
                                <div class="text-center">
                                    <button class="btn btn-primary btn-sm" @click="expertValuation()">
                                        GET MY OFFER
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <footer>
            <div class="container position-relative">
                <a href="javascript:void(0)" @click.prevent="goBack" class="btn btn-primary d-none d-md-inline-block">
                <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
                </a>
                <div class="text-center p-4">
                    <p class="text-center text-muted mb-1" style="font-weight: bold">© {{ new Date().getFullYear() }} RedBuyers</p>
                    <small style="font-weight: bold" class="d-block text-center text-muted mb-2"
                        >We respect your privacy, we will never sell or share
                        your information with anyone.</small
                    >
                    <small><a style="color: #212529; font-weight: bold; text-decoration: none;" href="/terms-and-conditions">Terms of Service</a> - <a style="color: #212529; font-weight: bold; text-decoration: none;" href="/privacy-policy">Privacy Policy</a></small>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: "PropertyValuationStepEightUpdated",
    data() {
        return {
            selectedAddress: "Toronto",
            name: "",
            email: "",
            phone: "",
        };
    },
    mounted() {
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
        }
        if (sessionStorage.getItem("valuation_name")) {
            this.name = sessionStorage.getItem("valuation_name");
        }
        if (sessionStorage.getItem("valuation_email")) {
            this.email = sessionStorage.getItem("valuation_email");
        }
        if (sessionStorage.getItem("valuation_phone")) {
            this.phone = sessionStorage.getItem("valuation_phone");
        }
        // if (sessionStorage.getItem("redirection_link")) {
        //     let url = 'https://redbuyers.com' + sessionStorage.getItem("redirection_link").toString();
        //     window.open(url, '_blank').focus();
        // }
    },
    methods: {
        submitForm() {
            window.location.href = "/properties/valuation/submit/data/step-9";
        },
        goBack() {
            window.location.href = "/properties/valuation/submit/data/step-7";
        },
        expertValuation() {
            // window.location.href = `/appointment/${this.name}/${this.email}/${this.phone}`;
            window.location.href = "/properties/valuation/submit/data/step-10";
        },
        goToHome() {
            window.location.href = "/";
        }
    }
};
</script>
